import { all, fork } from 'redux-saga/effects'
import {
  watchGetAuthUserData,
  watchGetClientPermissions,
  watchGetVersionDetails,
} from './sagas/auth.saga'
import {
  watchGetAllCompendias,
  watchFetchSingleCompendia,
} from './sagas/compendia.saga'
import {
  watchCreateFda,
  watchFetchAllFDAByPage,
  watchFetchAllFdas,
  watchFetchSingleFda,
  watchPatchToggleUpdateBulkDisableFda,
  watchPatchToggleUpdateBulkEnableFda,
  watchPatchToggleUpdateDisableFda,
  watchPatchToggleUpdateEnableFda,
  watchResetFda,
  watchUpdateFda,
} from './sagas/approvedIndication.saga'
import {
  watchCreateAddProducts,
  watchFetchAllAddProducts,
  watchFetchAllAddProductsByPage,
  watchFetchSingleAddProducts,
  watchGetAddProductsBySort,
  watchPatchToggleUpdateBulkDisableAddProducts,
  watchPatchToggleUpdateBulkEnableAddProducts,
  watchPatchToggleUpdateDisableAddProducts,
  watchPatchToggleUpdateEnableAddProducts,
  watchResetAddProducts,
  watchUpdateAddProducts,
} from './sagas/addProduct.saga'
import {
  watchBookmarkedEntities,
  watchFetchAllEntities,
  watchFetchAllEntitiesAgent,
  watchFetchAllEntitiesPaginated,
  watchFetchDeleteEntity,
  watchToggleEntity,
  watchUpdateBookmarkedEntites,
} from './sagas/entity.saga'
import {
  watchCreateHcpcsCode,
  watchFetchAllHcpcsCodes,
  watchFetchHcpcsCodeById,
  watchFetchUpdteHcpcsCodeById,
  watchHcpcsCodeSort,
  watchPatchToggleUpdateBulkDisableHcpcsCode,
  watchPatchToggleUpdateDisableHcpcsCode,
} from './sagas/hcpcsCode.saga'
import {
  watchCptCodeSort,
  watchCreateCptCode,
  watchFetchAllCptCodes,
  watchFetchCptCodeById,
  watchFetchProductById,
  watchFetchUpdteCptCodeById,
  watchPatchToggleUpdateBulkDisableCptCode,
  watchPatchToggleUpdateDisableCptCode,
} from './sagas/cptCode.saga'

import {
  watchCreateProductPricing,
  watchFetchAllProductPricing,
  watchFetchProductPricingByPage,
  watchfetchSingleProductPricing,
  watchUpdateProductPricing,
  watchFetchProductByIdInProductPricing,
  watchPatchToggleUpdateProductPricing,
  watchPatchToggleBulkUpdateProductPricing,
} from './sagas/productPricing.saga'
import {
  watchDeleteUser,
  watchFetchAllUsers,
  watchFetchAllUsersAssignRoles,
  watchFetchAllUsersByPage,
  watchGetUserListBySearch,
  watchGetUserListBySort,
  watchPatchToggleUpdateDisable,
  watchPatchToggleUpdateDisableBulk,
  watchPatchToggleUpdateEnable,
  watchPatchToggleUpdateEnableBulk,
} from './sagas/userlist.saga'
import { watchFetchAssignedRoles } from './sagas/role.saga'
import {
  watchClearAllClients,
  watchCreateClient,
  watchFetchAllClients,
  watchFetchSingleClient,
  watchPatchToggleUpdateBulkDisableClient,
  watchPatchToggleUpdateBulkEnableClient,
  watchPatchToggleUpdateDisableClient,
  watchPatchToggleUpdateEnableClient,
  watchResetClient,
  watchUpdateClient,
  watchFetchAllAddClientsByPage,
  watchGetAddClientsBySort,
} from './sagas/clientConfig.saga'

import {
  watchCreateProgram,
  watchFetchSingleProgram,
  watchGetAllPrograms,
  watchPatchToggleUpdateBulkDisableProgram,
  watchPatchToggleUpdateDisableProgram,
  watchResetProgram,
  watchUpdateProgram,
} from './sagas/program.saga'

import {
  watchCreateNdcCodes,
  watchFetchAllNdcCodes,
  watchFetchNdcCodesByPage,
  watchfetchSingleNdcCodes,
  watchNdcCodesSort,
  watchUpdateNdcCodes,
  watchFetchProductByIdInNdcCodes,
  watchPatchToggleBulkUpdateNdcCodes,
  watchPatchToggleUpdateNdcCodes,
} from './sagas/ndcCodes.saga'
import { watchSaveLayout, watchUpdateLayout } from './sagas/layouts.sage'
import {
  watchCreateProgramHoliday,
  watchDeleteProgramHoliday,
  watchFetchAllProgramsHoliday,
  watchUpdateProgramHoliday,
} from './sagas/programHolidays.saga'
import {
  watchFetchFieldPermissions,
  // watchFetchPermissionsById,
  // watchUpdatePermissions,
} from './sagas/permissions.saga'
import {
  watchFetchFontStyles,
  watchFetchHCPDataByApi,
  watchFetchHCPDataById,
  watchFetchHCPProgramData,
  watchGetHCPEnrollmentJSON,
  watchGetHCPProgramWorkingHours,
  watchPutHCPData,
  watchUpdateHCPValueSaga,
} from './sagas/hcpPortal.saga'
import {
  watchFetchAuditHistoryData,
  watchFetchAuditHistoryMetaData,
} from './sagas/audit.saga'

import {
  watchFetchAllMacros,
  watchFetchSingleMacro,
  watchPatchToggleMacro,
  watchDeleteSingleMacro,
} from './sagas/macros.saga'
import {
  watchCreateDocumentTemplateSaga,
  watchDeleteDocumentTemplateSaga,
  watchEnableDisabletogglerDocumentTemplateSaga,
  watchFetchDocumentTemplateById,
  watchGetAllDocumentTemplateSaga,
  watchSaveAsDraftDocumentTemplateSaga,
  watchUpdateDocumentTemplateSaga,
} from './sagas/documentTemplate.saga'
import {
  watchAddEmailTemplateSaga,
  watchGetEmailTemplateByIdSaga,
  watchGetAllEmailTemplatesSaga,
  watchGetEmailTemplateByCorrespondenceTypeAndProgram,
  watchUpdateEmailTemplateSaga,
  watchDeleteEmailTemplateByIdSaga,
  watchPatchBulkToggleUpdateSaga,
  watchSaveAsDraftEmailTemplateSaga,
  watchGetAttachmentPreviewSaga,
} from './sagas/templateManager.saga'
import { watchfetchPreviewTemplateData } from './sagas/manualCommunication.saga'
import {
  watchCreateProgramWorkingHours,
  watchDeleteProgramWorkingHours,
  watchFetchSingleProgramWorkingHours,
  watchGetAllProgramsWorkingHours,
  watchUpdateProgramWorkingHours,
} from './sagas/programWorkingHours.saga'
import {
  watchCheckExistingFacilityData,
  watchcheckHCPUserEmailData,
  watchClientData,
  watchFetchHcpConfigurationData,
  watchFetchNPIData,
  watchFetchProgramClientInfoData,
  watchFetchProviderAssociatedFacilitiesData,
  watchFetchProviderInfoData,
  watchFetchSearchFacilityData,
  watchFetchStatesData,
  watchFetchWorkingHoursByDateData,
  watchPostFinalOnboardingPayloadData,
} from './sagas/hcpOnboarding.saga'
import {
  watchFetchAllHcpConsent,
  watchPutAllHcpConsentData,
} from './sagas/hcpConsent.saga'
import {
  watchFetchPreviewCorrespondenceData,
  watchFilterAllCorrespondenceLogs,
} from './sagas/correspondenceLogs.saga'
import { watchFetchClientPermissionsById } from './sagas/clientPermissions.saga'
import {
  watchFetchSlaManagementData,
  watchFetchSlaManagementPaginatedData,
} from './sagas/slaManagement.saga'

import {
  watchFetchHCPAuthData,
  watchLogoutHCPAuthData,
} from './sagas/hcpAuth.saga'
import {
  watchFetchEnrollmentProviderFacilitiesData,
  watchFetchEnrollmentStaffFacilitiesData,
  watchFetchLoggedInDetailsData,
} from './sagas/hcpEnrollmentFlow.saga'
import {
  watchFetchServicesRequested,
  watchUpdateServiceStatus,
} from './sagas/hcpServiceRequested.saga'
import {
  watchFetchNotificationsListData,
  watchFetchNotificationsListPaginatedData,
} from './sagas/notification.saga'
import { watchFetchAllPermissions } from './sagas/allPermissions.saga'
import { watchFetchCategoryDropdown } from './sagas/categoryDropdown.saga'
import {
  watchFetchAllClientPrograms,
  watchSyncProgramOnTenantChange,
} from './sagas/clientPrograms.saga'
import {
  watchMsBackendAuthInit,
  watchMsBackendLogout,
} from './sagas/msBackendAuth.saga'
export {
  msBackendAuthInit,
  msBackendLogout,
  performMsBackendTokenRefresh,
  MS_BACKEND_LOGIN_ATTEMPT_KEY,
} from './sagas/msBackendAuth.saga'
export const getAdminPortalRootSaga = () => {
  return function* () {
    yield all([
      //Authentication user
      fork(watchGetAuthUserData),
      // Backend-managed Microsoft login (MS_BACKEND). Admin-desk runs the same
      // hardened cookie + CSRF flow as agent-desk — see EP-653.
      fork(watchMsBackendAuthInit),
      fork(watchMsBackendLogout),
      fork(watchGetVersionDetails),

      // Entities
      fork(watchFetchAllEntities),
      fork(watchFetchAllEntitiesPaginated),
      fork(watchFetchDeleteEntity),
      fork(watchToggleEntity),

      //layout
      fork(watchUpdateLayout),
      fork(watchSaveLayout),

      // clients
      fork(watchFetchAllClients),
      fork(watchClearAllClients),
      fork(watchCreateClient),
      fork(watchPatchToggleUpdateBulkDisableClient),
      fork(watchFetchSingleClient),
      fork(watchPatchToggleUpdateBulkEnableClient),
      fork(watchPatchToggleUpdateDisableClient),
      fork(watchPatchToggleUpdateEnableClient),
      fork(watchResetClient),
      fork(watchUpdateClient),
      fork(watchFetchAllAddClientsByPage),
      fork(watchGetAddClientsBySort),

      // cpt and hcpcs
      fork(watchHcpcsCodeSort),
      fork(watchFetchAllHcpcsCodes),
      fork(watchCreateHcpcsCode),
      fork(watchFetchHcpcsCodeById),
      fork(watchFetchUpdteHcpcsCodeById),
      fork(watchPatchToggleUpdateBulkDisableHcpcsCode),
      fork(watchPatchToggleUpdateDisableHcpcsCode),
      fork(watchFetchAllCptCodes),
      fork(watchCptCodeSort),
      fork(watchCreateCptCode),
      fork(watchFetchCptCodeById),
      fork(watchFetchUpdteCptCodeById),
      fork(watchPatchToggleUpdateBulkDisableCptCode),
      fork(watchPatchToggleUpdateDisableCptCode),
      fork(watchFetchProductById),

      //fda
      fork(watchFetchAllFdas),
      fork(watchFetchSingleFda),
      fork(watchFetchAllFDAByPage),
      fork(watchCreateFda),
      fork(watchUpdateFda),
      fork(watchResetFda),
      fork(watchPatchToggleUpdateBulkDisableFda),
      fork(watchPatchToggleUpdateBulkEnableFda),
      fork(watchPatchToggleUpdateDisableFda),
      fork(watchPatchToggleUpdateEnableFda),
      fork(watchFetchSingleAddProducts),

      // Products
      fork(watchCreateAddProducts),
      fork(watchFetchAllAddProducts),
      fork(watchFetchAllAddProductsByPage),
      fork(watchFetchSingleAddProducts),
      fork(watchGetAddProductsBySort),
      fork(watchUpdateAddProducts),
      fork(watchResetAddProducts),
      fork(watchPatchToggleUpdateDisableAddProducts),
      fork(watchPatchToggleUpdateEnableAddProducts),
      fork(watchPatchToggleUpdateBulkDisableAddProducts),
      fork(watchPatchToggleUpdateBulkEnableAddProducts),

      //userlist
      fork(watchFetchAllUsersByPage),
      fork(watchFetchAllUsers),
      fork(watchFetchAllUsersAssignRoles),
      fork(watchPatchToggleUpdateDisable),
      fork(watchPatchToggleUpdateEnable),
      fork(watchPatchToggleUpdateDisableBulk),
      fork(watchPatchToggleUpdateEnableBulk),
      fork(watchGetUserListBySort),
      fork(watchGetUserListBySearch),
      fork(watchDeleteUser),

      //role
      fork(watchFetchAssignedRoles),

      //compendia
      fork(watchGetAllCompendias),
      fork(watchFetchSingleCompendia),

      //programs
      fork(watchGetAllPrograms),
      fork(watchCreateProgram),
      fork(watchFetchSingleProgram),
      fork(watchUpdateProgram),
      fork(watchPatchToggleUpdateDisableProgram),
      fork(watchResetProgram),
      fork(watchPatchToggleUpdateBulkDisableProgram),

      //ndcCodes
      fork(watchFetchAllNdcCodes),
      fork(watchfetchSingleNdcCodes),
      fork(watchCreateNdcCodes),
      fork(watchUpdateNdcCodes),
      fork(watchFetchNdcCodesByPage),
      fork(watchNdcCodesSort),
      fork(watchFetchProductByIdInNdcCodes),
      fork(watchPatchToggleBulkUpdateNdcCodes),
      fork(watchPatchToggleUpdateNdcCodes),

      //productPricing
      fork(watchFetchAllProductPricing),
      fork(watchfetchSingleProductPricing),
      fork(watchCreateProductPricing),
      fork(watchUpdateProductPricing),
      fork(watchFetchProductPricingByPage),
      fork(watchFetchProductByIdInProductPricing),
      fork(watchPatchToggleUpdateProductPricing),
      fork(watchPatchToggleBulkUpdateProductPricing),

      //Program Holiday
      fork(watchFetchAllProgramsHoliday),
      fork(watchCreateProgramHoliday),
      fork(watchDeleteProgramHoliday),
      fork(watchUpdateProgramHoliday),

      //permissions
      // fork(watchFetchPermissionsById),
      // fork(watchUpdatePermissions),

      //clientPermissions
      fork(watchFetchClientPermissionsById),

      //Macros
      fork(watchFetchAllMacros),
      fork(watchFetchSingleMacro),
      fork(watchPatchToggleMacro),
      fork(watchDeleteSingleMacro),

      //hcp portal
      fork(watchFetchHCPProgramData),
      fork(watchFetchHCPDataById),
      fork(watchPutHCPData),
      fork(watchGetHCPEnrollmentJSON),
      fork(watchGetHCPProgramWorkingHours),
      fork(watchFetchHCPDataByApi),
      fork(watchUpdateHCPValueSaga),
      fork(watchFetchFontStyles),

      //document template
      fork(watchGetAllDocumentTemplateSaga),
      fork(watchCreateDocumentTemplateSaga),
      fork(watchFetchDocumentTemplateById),
      fork(watchUpdateDocumentTemplateSaga),
      fork(watchEnableDisabletogglerDocumentTemplateSaga),
      fork(watchDeleteDocumentTemplateSaga),
      fork(watchSaveAsDraftDocumentTemplateSaga),

      //template Manager
      fork(watchAddEmailTemplateSaga),
      fork(watchGetEmailTemplateByIdSaga),
      fork(watchGetAllEmailTemplatesSaga),
      fork(watchGetEmailTemplateByCorrespondenceTypeAndProgram),
      fork(watchUpdateEmailTemplateSaga),
      fork(watchDeleteEmailTemplateByIdSaga),
      fork(watchPatchBulkToggleUpdateSaga),
      fork(watchSaveAsDraftEmailTemplateSaga),
      // view role audit history
      fork(watchFetchAuditHistoryData),
      fork(watchFetchAuditHistoryMetaData),

      //Send Manual Communication
      fork(watchfetchPreviewTemplateData),
      fork(watchGetAttachmentPreviewSaga),

      //program working hours
      fork(watchCreateProgramWorkingHours),
      fork(watchUpdateProgramWorkingHours),
      fork(watchFetchSingleProgramWorkingHours),
      fork(watchGetAllProgramsWorkingHours),
      fork(watchDeleteProgramWorkingHours),

      //hcpConsent
      fork(watchFetchAllHcpConsent),
      fork(watchPutAllHcpConsentData),

      //hcpServiceRequisted
      fork(watchFetchServicesRequested),
      fork(watchUpdateServiceStatus),

      // correspondence Logs
      fork(watchFilterAllCorrespondenceLogs),
      fork(watchFetchPreviewCorrespondenceData),
      fork(watchGetClientPermissions),

      // sla management
      fork(watchFetchSlaManagementData),
      fork(watchFetchSlaManagementPaginatedData),

      // notification template
      fork(watchFetchNotificationsListData),
      fork(watchFetchNotificationsListPaginatedData),

      //all permisions
      fork(watchFetchAllPermissions),
    ])
  }
}

export const getAgentPortalRootSaga = () => {
  return function* () {
    yield all([
      fork(watchGetAuthUserData),
      fork(watchMsBackendAuthInit),
      fork(watchMsBackendLogout),
      fork(watchFetchAllEntities),
      //layout
      fork(watchUpdateLayout),
      fork(watchBookmarkedEntities),
      fork(watchUpdateBookmarkedEntites),
      fork(watchFetchAllEntitiesAgent),

      //auth
      fork(watchGetClientPermissions),
      fork(watchFetchFieldPermissions),
      fork(watchGetVersionDetails),
      // correspondence Logs
      fork(watchFilterAllCorrespondenceLogs),
      fork(watchFetchPreviewCorrespondenceData),

      //clientPermissions
      fork(watchFetchClientPermissionsById),

      fork(watchFetchCategoryDropdown),
      //client Programs
      fork(watchFetchAllClientPrograms),
      fork(watchSyncProgramOnTenantChange),

      //all permisions
      fork(watchFetchAllPermissions),
    ])
  }
}

//hcp onboarding
export const getHcpPortalRootSaga = () => {
  return function* () {
    yield all([
      fork(watchFetchNPIData),
      fork(watchFetchProviderInfoData),
      fork(watchFetchStatesData),
      fork(watchFetchSearchFacilityData),
      fork(watchcheckHCPUserEmailData),
      fork(watchFetchProviderAssociatedFacilitiesData),
      fork(watchCheckExistingFacilityData),
      fork(watchPostFinalOnboardingPayloadData),
      fork(watchClientData),
      fork(watchFetchHCPDataByApi),
      fork(watchFetchProgramClientInfoData),
      fork(watchFetchHcpConfigurationData),
      fork(watchFetchWorkingHoursByDateData),
      fork(watchFetchEnrollmentStaffFacilitiesData),
      fork(watchFetchHCPAuthData),
      fork(watchFetchEnrollmentProviderFacilitiesData),
      fork(watchFetchServicesRequested),
      fork(watchFetchLoggedInDetailsData),
      fork(watchFetchAllHcpConsent),
      fork(watchLogoutHCPAuthData),
    ])
  }
}
//web consent
export const getWebConsentPortalRootSaga = () => {
  return function* () {
    yield all([])
  }
}
